import React from 'react'
import { Box, Container, Grid, Typography } from '@mui/material'
function About() {
    return (
        <>
            <Container sx={{ padding: { xs: "15px 10px", md: "20px 10px", lg: "40px 15px" }, textAlign: "center" }} >
                <Grid container spacing={10} style={{ alignItems: "center" }}>
                    <Grid item md={6} >
                        <Typography variant='h4' style={{ marginBottom: "15px", fontWeight: "bold", textAlign: "center" }} sx={{ fontSize: { xs: '28px', sm: '32px', md: '40px' } }}>
                            About Our Grocery Shop
                        </Typography>
                        <Typography textAlign={'justify'} >
                            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Est aut atque facere placeat recusandae ab reprehenderit nemo voluptas beatae molestiae explicabo, pariatur possimus neque quis rem tenetur hic qui praesentium aspernatur, ea quibusdam. Quia quisquam ullam deleniti quos libero incidunt voluptatem? Necessitatibus doloremque harum beatae praesentium. Dicta nostrum, officiis aspernatur eveniet, nesciunt iusto commodi quasi consequatur mollitia ipsa repellat fugiat magnam sequi voluptatibus modi beatae necessitatibus, qui architecto eius consequuntur! Cumque autem amet reprehenderit eaque sit corporis placeat ipsa eligendi sunt. Molestiae repudiandae non facilis, dolor itaque temporibus assumenda dicta, ipsa nam ipsam alias, hic ex rem recusandae harum est!  libero incidunt voluptatem? Necessitatibus doloremque harum beatae praesentium. Dicta nostrum, officiis aspernatur eveniet, nesciunt iusto commodi .
                        </Typography>
                    </Grid>
                    <Grid item md={6} >
                        <Box
                            component="img"
                            sx={{
                                height: 'auto',
                                width: '100%',
                                // margin: '10px auto'
                            }}
                            alt="The house from the offer."
                            src="./assets/image/shop.jpg"
                        />
                    </Grid>
                </Grid>
            </Container>
            <Container sx={{ padding: { xs: "15px 10px", md: "20px 10px", lg: "40px 15px" }, textAlign: "center" }}>
                <Typography variant='h4' style={{ marginBottom: "15px", fontWeight: "bold", textAlign: "center" }} sx={{ fontSize: { xs: '28px', sm: '32px', md: '40px' } }}>
                    Why Choose us ?
                </Typography>

                <Grid container sx={{ gap: { md: '0px', xs: '20px' } }} style={{ justifyContent: "center", }}>
                    <Grid item lg={3} md={6} sm={6} xs={12}>
                        <Box
                            component="img"
                            sx={{
                                height: 90,
                                width: 90,
                                margin: '10px auto'
                            }}
                            alt="The house from the offer."
                            src="./assets/image/delivery-bike.png"
                        />
                        <Typography style={{ fontWeight: 'bold' }} >
                            10 Minutes Delivery
                        </Typography>
                    </Grid>
                    <Grid item lg={3} md={6} sm={6} xs={12}>
                        <Box
                            component="img"
                            sx={{
                                height: 90,
                                width: 90,
                                margin: '10px auto'
                            }}
                            alt="The house from the offer."
                            src="./assets/image/discount.png"
                        />
                        <Typography style={{ fontWeight: 'bold' }} >
                            Upto 60% Discount
                        </Typography>
                    </Grid>
                    <Grid item lg={3} md={6} sm={6} xs={12}>
                        <Box
                            component="img"
                            sx={{
                                height: 90,
                                width: 90,
                                margin: '10px auto'
                            }}
                            alt="The house from the offer."
                            src="./assets/image/grocery-cart.png"
                        />
                        <Typography style={{ fontWeight: 'bold' }} >
                            10000+ Product Available
                        </Typography>
                    </Grid>
                    <Grid item lg={3} md={6} sm={6} xs={12}>
                        <Box
                            component="img"
                            sx={{
                                height: 90,
                                width: 90,
                                margin: '10px auto'
                            }}
                            alt="The house from the offer."
                            src="./assets/image/fresh.png"
                        />
                        <Typography style={{ fontWeight: 'bold' }} >
                            Fresh, Natural and Organic
                        </Typography>
                    </Grid>
                </Grid>
            </Container >
            <Container sx={{ padding: { xs: "15px 10px", md: "20px 10px", lg: "40px 15px" } }} >
                <Grid container spacing={2} style={{ alignItems: "center" }}>
                    <Grid item md={6} >
                        <Box
                            component="img"
                            sx={{
                                height: 'auto',
                                width: '100%',
                                // margin: '10px auto'
                            }}
                            alt="The house from the offer."
                            src="./assets/image/mission.jpg"
                        />
                    </Grid>
                    <Grid item md={6} >
                        <Typography variant='h4' style={{ marginBottom: "15px", fontWeight: "bold",  }} sx={{ fontSize: { xs: '28px', sm: '32px', md: '40px' } }}>
                            Our Mission
                        </Typography>
                        <Typography textAlign={'justify'} >
                            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Est aut atque facere placeat recusandae ab reprehenderit nemo voluptas beatae molestiae explicabo, pariatur possimus neque quis rem tenetur hic qui praesentium aspernatur, ea quibusdam. Quia quisquam ullam deleniti quos libero incidunt voluptatem? Necessitatibus doloremque harum beatae praesentium. Dicta nostrum, officiis aspernatur eveniet, nesciunt iusto commodi quasi consequatur mollitia ipsa repellat fugiat magnam sequi voluptatibus modi beatae necessitatibus, qui architecto eius consequuntur! Cumque autem amet reprehenderit eaque sit corporis placeat ipsa eligendi sunt. Molestiae repudiandae non facilis.
                        </Typography>
                    </Grid>

                </Grid>
            </Container>
            <Container sx={{ padding: { xs: "15px 10px", md: "20px 10px", lg: "40px 15px" } }}  >
                <Grid container spacing={2} style={{ alignItems: "center" }}>
                    <Grid item md={6} >
                        <Typography variant='h4' style={{ marginBottom: "15px", fontWeight: "bold", }} sx={{ fontSize: { xs: '28px', sm: '32px', md: '40px' } }}>
                            Our Vision
                        </Typography>
                        <Typography textAlign={'justify'} >
                            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Est aut atque facere placeat recusandae ab reprehenderit nemo voluptas beatae molestiae explicabo, pariatur possimus neque quis rem tenetur hic qui praesentium aspernatur, ea quibusdam. Quia quisquam ullam deleniti quos libero incidunt voluptatem? Necessitatibus doloremque harum beatae praesentium. Dicta nostrum, officiis aspernatur eveniet,
                        </Typography>
                    </Grid>
                    <Grid item md={6} >
                        <Box
                            component="img"
                            sx={{
                                height: 'auto',
                                width: '100%',
                                // margin: '10px auto'
                            }}
                            alt="The house from the offer."
                            src="./assets/image/vision.jpg"
                        />
                    </Grid>
                </Grid>
            </Container>
        </>
    )
}

export default About